var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgB3IndoorHumidity(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.37 3.63L3 25.89V69h70V25.9L38.37 3.63zM69 65H7V28.1L38.35 8.37 69 28.08V65zM36.5 35.46c0-4.72 5.69-9.56 7-15 1.31 5.4 7 10.24 7 15a7.001 7.001 0 01-11.95 4.95 7 7 0 01-2.05-4.95zm-8 2c1.31 5.4 7 10.24 7 15a7 7 0 01-14 0c0-4.72 5.69-9.56 7-14.96v-.04z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/B3_Indoor_humidity.c454fddb.svg";
export { SvgB3IndoorHumidity as ReactComponent };